import React from "react";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import "./pricingfeatures.css";

const PricingFeatures = () => {
    const { t } = useTranslation();

    const features = [
        {
            category: "User Features",
            features: [
                {
                    name: "Native IOS and android app",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "App integrations (Fitbit, Garmin etc.)",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Individual and team leaderboards",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Steps tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Outdoor activities tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Food tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Guided mindfulness sessions",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Sleep tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Heart rate tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Mood tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "AI-powered squat tracker",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Wellness social feed",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Marketplace access",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Wellness library",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                { name: "Group chat", oneTime: 0, standard: 0, enterprise: 1 },
            ],
        },
        {
            category: "Challenge & Program Management",
            features: [
                {
                    name: "No of challenges",
                    oneTime: "1",
                    standard: "Unlimited",
                    enterprise: "Unlimited",
                },
                {
                    name: "Dashboard access",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                { name: "Onboarding", oneTime: 1, standard: 1, enterprise: 1 },
                {
                    name: "12 Predefined challenges to choose from",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Marketing collaterals for 12 predefined challenges",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Best in class customer support",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Team challenges",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Inter department challenges",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Inter city challenges",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Customizable incentives",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Challenge rewards distribution",
                    oneTime: 1,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Customizable communications",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Custom data capture",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "On demand wellness webinars",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Account manager",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
                {
                    name: "Expert guided implementation",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
                {
                    name: "Program planning",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
            ],
        },
        {
            category: "Add-Ons",
            features: [
                {
                    name: "Pre-welcome survey",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Welcome mailer 1",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "Welcome mailer 2",
                    oneTime: 0,
                    standard: 1,
                    enterprise: 1,
                },
                {
                    name: "SSO login and HRMS integrations",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
                {
                    name: "Quarterly business reviews",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
                {
                    name: "Quarterly wellness surveys",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
                {
                    name: "Company timeline walkathon",
                    oneTime: 0,
                    standard: 0,
                    enterprise: 1,
                },
            ],
        },
    ];

    // Render tick SVG based on plan flag and color
    const renderTick = (plan) => {
        if (typeof plan === "string") {
            return (
                <span
                    className={`${
                        plan == "1" ? "mr-5 pr-lg-2 " : "ml-5 pl-lg-2 "
                    } feature-name `}
                >
                    {t(plan)}
                </span>
            );
        }
        switch (plan) {
            case 1:
                return (
                    <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                        >
                            <g
                                transform="translate(-1019.000000, -2716.000000)"
                                fillRule="nonzero"
                            >
                                <path d="M1020.66312,2723.30713 C1020.02041,2723.30898 1019.43592,2723.68952 1019.16068,2724.28532 C1018.88545,2724.88112 1018.96844,2725.58615 1019.37403,2726.09761 L1023.61042,2731.42119 C1023.91688,2731.81155 1024.38818,2732.02615 1024.87597,2731.99745 C1025.39017,2731.96912 1025.85441,2731.68695 1026.15039,2731.22299 L1034.95045,2716.68453 C1034.95189,2716.68212 1034.95339,2716.6797 1034.95494,2716.67733 C1035.0375,2716.54728 1035.01073,2716.28954 1034.8403,2716.12763 C1034.74567,2716.03777 1034.61905,2715.992 1034.49041,2716.00115 C1034.36176,2716.0103 1034.24252,2716.07357 1034.16089,2716.17598 C1034.15773,2716.17996 1034.15448,2716.18388 1034.15114,2716.18775 L1025.27616,2726.47409 C1025.20795,2726.55316 1025.11169,2726.60088 1025.00891,2726.60658 C1024.90614,2726.61228 1024.80542,2726.57549 1024.72929,2726.50443 L1021.78386,2723.75485 C1021.47795,2723.46718 1021.07812,2723.30745 1020.66312,2723.30713 L1020.66312,2723.30713 Z"></path>
                            </g>
                        </g>
                    </svg>
                );
            default:
                return (
                    <svg
                        width="14px"
                        height="14px"
                        viewBox="0 0 14 14"
                        fill="#F15162"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                        >
                            <g
                                transform="translate(-795.000000, -2822.000000)"
                                fill="#F15162"
                                fillRule="nonzero"
                            >
                                <g
                                    id="Group-Copy-18"
                                    transform="translate(795.000000, 2822.000000)"
                                >
                                    <path
                                        d="M0.907335158,14 C0.675145039,14 0.442788843,13.9111414 0.266071915,13.7342547 C-0.0886906384,13.3796509 -0.0886906384,12.8063055 0.266071915,12.4517017 L12.4514016,0.265952879 C12.8059981,-0.0886509597 13.3793316,-0.0886509597 13.7339281,0.265952879 C14.0886906,0.620556718 14.0886906,1.19390211 13.7339281,1.54850595 L1.54859836,13.7342547 C1.37071881,13.9119719 1.13952524,14 0.907335158,14 Z"
                                        id="Path"
                                    ></path>
                                    <path
                                        d="M13.0926649,14 C12.8604748,14 12.6282846,13.9111414 12.4514016,13.7342547 L0.266071915,1.54850595 C-0.0886906384,1.19390211 -0.0886906384,0.620556718 0.266071915,0.265952879 C0.620668392,-0.0886509597 1.19383581,-0.0886509597 1.54859836,0.265952879 L13.7339281,12.4517017 C14.0886906,12.8063055 14.0886906,13.3796509 13.7339281,13.7342547 C13.557045,13.9119719 13.324855,14 13.0926649,14 L13.0926649,14 Z"
                                        id="Path"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                );
        }
    };

    return (
        <div className="pricing-features">
            <div className="container custom_container pricing-features-1 price-cont-wrapper">
                <div className="row mb-md-4 align-items-center justify-content-between pricing-feat-wrapper">
                    <div className="col-md-6 core-feat">
                        <h2>
                            <Trans>Core Features</Trans>
                        </h2>
                    </div>
                    <div className="col-md-6 px-0">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="row align-items-center justify-content-end text-center">
                                    <div className="col-4 plan-name purple">
                                        <h3>
                                            <Trans>One-time</Trans>
                                        </h3>
                                    </div>

                                    <div className="col-4 plan-name green">
                                        <h3>
                                            <Trans>Standard</Trans>
                                        </h3>
                                    </div>
                                    <div className="col-4 plan-name orange">
                                        <h3>
                                            <Trans>Enterprise</Trans>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {features.map((category, categoryIndex) => (
                    <div
                        className="row mb-4 pricing-feat-wrapper"
                        key={categoryIndex}
                    >
                        <div className="col-md-2 feature-name">
                            <h3>{t(category.category)}</h3>
                        </div>
                        <div className="col-md-10">
                            {category.features.map((feature, featureIndex) => (
                                <div
                                    className="row align-items-center feat-row"
                                    key={featureIndex}
                                >
                                    <div className="col-12 col-sm-6 feature-name">
                                        {t(feature.name)}
                                    </div>
                                    {/* <div className="col-5 d-flex justify-content-between">
                                <div className="purple">{renderTick(feature.oneTime)}</div>
                                <div className="green">{renderTick(feature.standard)}</div>
                                <div className="orange">{renderTick(feature.enterprise)}</div>
                            </div> */}
                                    <div className="col-12 col-sm-5 d-flex justify-content-between">
                                        <div
                                            className={
                                                feature.oneTime === 0
                                                    ? "red"
                                                    : "purple"
                                            }
                                        >
                                            {renderTick(feature.oneTime)}
                                        </div>
                                        <div
                                            className={
                                                feature.standard === 0
                                                    ? "red"
                                                    : "green"
                                            }
                                        >
                                            {renderTick(feature.standard)}
                                        </div>
                                        <div
                                            className={
                                                feature.enterprise === 0
                                                    ? "red"
                                                    : "orange"
                                            }
                                        >
                                            {renderTick(feature.enterprise)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PricingFeatures;
